/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CardBrandFees,
  CardBrandFees$inboundSchema,
  CardBrandFees$Outbound,
  CardBrandFees$outboundSchema,
} from "./cardbrandfees.js";

/**
 * A detailed breakdown of card acquiring fees by card brand.
 */
export type CardAcquiringFees = {
  /**
   * Fees associated with Visa transactions.
   */
  visa: CardBrandFees;
  /**
   * Fees associated with Mastercard transactions.
   */
  mastercard: CardBrandFees;
  /**
   * Fees associated with Discover transactions.
   */
  discover: CardBrandFees;
  /**
   * Fees associated with American Express transactions.
   */
  americanExpress: CardBrandFees;
};

/** @internal */
export const CardAcquiringFees$inboundSchema: z.ZodType<
  CardAcquiringFees,
  z.ZodTypeDef,
  unknown
> = z.object({
  visa: CardBrandFees$inboundSchema,
  mastercard: CardBrandFees$inboundSchema,
  discover: CardBrandFees$inboundSchema,
  americanExpress: CardBrandFees$inboundSchema,
});
/** @internal */
export type CardAcquiringFees$Outbound = {
  visa: CardBrandFees$Outbound;
  mastercard: CardBrandFees$Outbound;
  discover: CardBrandFees$Outbound;
  americanExpress: CardBrandFees$Outbound;
};

/** @internal */
export const CardAcquiringFees$outboundSchema: z.ZodType<
  CardAcquiringFees$Outbound,
  z.ZodTypeDef,
  CardAcquiringFees
> = z.object({
  visa: CardBrandFees$outboundSchema,
  mastercard: CardBrandFees$outboundSchema,
  discover: CardBrandFees$outboundSchema,
  americanExpress: CardBrandFees$outboundSchema,
});

export function cardAcquiringFeesToJSON(
  cardAcquiringFees: CardAcquiringFees,
): string {
  return JSON.stringify(
    CardAcquiringFees$outboundSchema.parse(cardAcquiringFees),
  );
}
export function cardAcquiringFeesFromJSON(
  jsonString: string,
): SafeParseResult<CardAcquiringFees, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CardAcquiringFees$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CardAcquiringFees' from JSON`,
  );
}
